/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationFieldMappingsSchema = z.object({
  estimateFieldId: z.string().nullish(),
  expectedFinishDateFieldId: z.string().nullish(),
  expectedStartDateFieldId: z.string().nullish(),
  plannedFinishDateFieldId: z.string().nullish(),
  plannedStartDateFieldId: z.string().nullish(),
  teamFieldId: z.string().nullish(),
});
